import { createSelector } from 'reselect';

import { initialState } from './reducer';

const selectState = (state: any) => state.get('corporateDonationLogForm') || initialState;

export const selectStatusUpdating = createSelector(selectState, (state) =>
  state.get('statusUpdating')
);

export const selectLoading = createSelector(selectState, (state) => state.get('loading'));

export const selectError = createSelector(selectState, (state) => state.get('error'));
